/**
 * Created by zhangxiaoqing on 2017/7/25.
 */
const getPageData = (pageSize, pageIndex, dataList) => {
  let endIndex = pageSize * pageIndex
  let startIndex = endIndex - pageSize
  return dataList.slice(startIndex < 0 ? 0 : startIndex, endIndex)
}

/** 生成验证码 */
const createCode = () => {
  let code = ''
  let codeLength = 4 // 验证码的长度
  let codeChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'] // 所有候选组成验证码的字符，当然也可以用中文的
  for (let i = 0; i < codeLength; i++) {
    let charNum = Math.floor(Math.random() * 52)
    code += codeChars[charNum]
  }
  return code
}

const routeHop = (router, pathName) => {
  router.go(0)
}
const formatDate = (date) => {
  if (!date) {
    return ''
  } else {
    let dateObj = new Date(date)
    let y = dateObj.getFullYear()
    let m = dateObj.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = dateObj.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + '-' + m + '-' + d
  }
}

// 获取url参数
const getUrlParam = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}

export {getPageData, createCode, routeHop, formatDate, getUrlParam}



// WEBPACK FOOTER //
// ./src/assets/js/common.js